import { render } from "./OpenTrip.vue?vue&type=template&id=38a46934&scoped=true"
import script from "./OpenTrip.vue?vue&type=script&lang=js"
export * from "./OpenTrip.vue?vue&type=script&lang=js"

import "./OpenTrip.vue?vue&type=style&index=0&id=38a46934&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a46934"]])

export default __exports__